export function getToggle(feature) {
    return feature === "cors-simple-request";
}
